import throttle from 'raf-throttle';

const offset = 80;
let isScrolled;

const callback = throttle(() => {
  const nowIsScrolled = window.pageYOffset >= offset;

  if (nowIsScrolled !== isScrolled) {
    isScrolled = nowIsScrolled;

    if (isScrolled) {
      document.body.classList.add('is-scrolled');
    } else {
      document.body.classList.remove('is-scrolled');
    }
  }
});

window.addEventListener('scroll', callback);
